import * as Three from 'three';

/**
 * Gaussian splat / PLY meshes are too heavy for Three.js Raycaster and freeze the editor.
 */

const noopRaycast = () => {};
const _plyPickBox = new Three.Box3();
const _plyPickPoint = new Three.Vector3();
export function isHeavyRaycastExcludedObject(obj) {
  let current = obj;
  while (current) {
    if (current.glb_type === 'ply') return true;
    if (current.userData?.raycastDisabled) return true;
    current = current.parent;
  }
  return false;
}

/** Disable Raycaster hits on a splat/PLY root and all descendants. */
export function disableSplatRaycast(object) {
  if (!object) return;

  const tag = (node) => {
    if (!node.userData) node.userData = {};
    node.userData.raycastDisabled = true;
    node.raycast = noopRaycast;
  };

  tag(object);
  object.traverse?.(tag);
}

function getPlyWorldBox(ply, targetBox) {
  targetBox.makeEmpty();

  if (typeof ply?.getBoundingBox === 'function' && ply.isInitialized) {
    try {
      ply.updateMatrixWorld?.(true);
      const localBox = ply.getBoundingBox(true);
      targetBox.copy(localBox).applyMatrix4(ply.matrixWorld);
      return targetBox;
    } catch (_) {
      // Fall through to generic bounds.
    }
  }

  ply.updateMatrixWorld?.(true);
  targetBox.setFromObject(ply);
  return targetBox;
}

/** Lightweight viewport pick for PLY roots (raycast is disabled on splats). */
export function pickClosestPlyFromRay(ray, objects) {
  if (!ray || !objects?.length) return null;

  let closest = null;
  let closestDistance = Infinity;

  for (const obj of objects) {
    if (obj?.glb_type !== 'ply' || obj.visible === false) continue;

    try {
      getPlyWorldBox(obj, _plyPickBox);
    } catch (_) {
      continue;
    }

    if (_plyPickBox.isEmpty()) continue;

    const hit = ray.intersectBox(_plyPickBox, _plyPickPoint);
    if (!hit) continue;

    const distance = ray.origin.distanceTo(hit);
    if (distance < closestDistance) {
      closestDistance = distance;
      closest = obj;
    }
  }

  return closest ? { object: closest, distance: closestDistance } : null;
}
